<template>
	<div class="app animated fadeIn">
		<AppHeader fixed>
			<SidebarToggler class="d-lg-none" display="md" mobile />
			<b-link class="navbar-brand" to="/">
				<img class="" @click="removeOpened" src="../../public/img/dutyFree.jpg"
					style="margin-left: 45px; height: 55px" alt="DutyFreeLogo">
			</b-link>
			<SidebarToggler class="d-md-down-none"
				style="margin-left: 45px; background-color: #4a453f; height: 55px; width: 80px; border-radius: 0;"
				display="lg" />
			<b-navbar-nav class="d-md-down-none">
				<b-nav-item class="px-4" @click="removeOpened" to="/dashboard"><b>{{ $t('dashboard') }}</b></b-nav-item>
			</b-navbar-nav>
			<b-navbar-nav class="ml-auto">
				<el-dropdown v-if="$can('contract-notification', 'view')" class="mr-3" trigger="click">
					<i style="position: relative; font-size: 20px; cursor: pointer; color: #ffd500"
						class="fa fa-bell" /><b-badge v-if="contracts && contracts.length > 0" class="text-white"
						style="position: absolute; top: -9px; right: -5px; border-radius: 50%; background-color: red">{{
							contracts.length }}</b-badge>
					<template #dropdown>
						<div v-if="notifyLoading" />
						<div v-if="!notifyLoading">
							<el-dropdown-menu v-if="contracts.length > 0">
								<el-dropdown-item v-for="(contract, index) in contracts" :key="`contract-${index}`"
									:divided="index !== 0">
									<div @click="goToContract(contract.id)"><b>{{ contract.contractNumber }} / {{
										contract.contractDate }} - {{ contract.endDate }} / {{
												contract.amountPriceUzs }} {{ contract.currencyCode }} / {{
												contract.contragentName }}</b> | <b class="text-white"
											style="background-color: #bb2c38; padding-left: 3px; padding-right: 3px">{{
												contract.paymentDate }} - {{ contract.paymentAmount }} {{
												contract.currencyCode }}</b></div>
								</el-dropdown-item>
							</el-dropdown-menu>
							<el-dropdown-menu v-else>
								<div class="m-3"><b>{{ $t('empty') }}</b></div>
							</el-dropdown-menu>
						</div>
						<div v-else>
							<el-dropdown-menu>
								<b-overlay :show="notifyLoading" rounded opacity="0">
									<div class="m-3"><b>{{ $t('empty') }}</b></div>
								</b-overlay>
							</el-dropdown-menu>
						</div>
					</template>
				</el-dropdown>
				<b-nav-item class="d-md-down-none mr-2">
					<b-nav-item-dropdown :text="$t('lang')" center>
						<b-dropdown-item class="header_language_item" v-for="(value, key) in locales" :key="key"
							@click="changeLocale(key)" href="javascript:void(0)">
							<i :class="'flag-icon flag-icon-' + key.substring(0, 2)" :name="value"></i>
							{{ value }}
						</b-dropdown-item>
					</b-nav-item-dropdown>
				</b-nav-item>
				<b-nav-item class="d-md-down-none">
					<span id="userName">{{ this.userName }}</span>
				</b-nav-item>

				<DefaultHeaderDropdownAccnt @childClicked="logout" @changePassword="showChangePasswordModal" />
				<b-modal v-model="passwordModal" hide-footer ok-title="save" @shown="$refs.currentPasswordRef.focus()">
					<div slot="modal-header">
						<h5 slot="modal-title" class="mb-0">{{ $t('users-l.update.title') }} - <strong>{{
							currentUserName
								}}</strong></h5>
					</div>
					<div style="margin: 25px;">
						<p v-if="isIncorrectForm" style="color: red;">{{ $t('users-l.create.please-title') }}</p>
						<p v-if="passwordMismatch" style="color: red;">{{ $t('users-l.update.please-title') }}</p>
						<p v-if="hasPasswordError" style="color: red;">{{ passwordErrorMessage }}</p>

						<b-form-group label-align-sm="right" label-for="currentPasswordProfile" size="sm">
							<b-input-group-prepend>
								<span class="input-group-text"><i class="fa fa-key"></i></span>
								<b-form-input ref="currentPasswordRef" size="sm" type="password"
									:placeholder="$t('users-l.update.password')" id="currentPasswordProfile"
									v-model="payload.currentPassword" />
							</b-input-group-prepend>
						</b-form-group>
						<b-form-group label-align-sm="right" label-for="newPasswordProfile" size="sm">
							<b-input-group-prepend>
								<span class="input-group-text"><i class="fa fa-key"></i></span>
								<b-form-input size="sm" type="password" :placeholder="$t('users-l.update.newpassword')"
									id="newPasswordProfile" v-model="payload.newPassword" />
							</b-input-group-prepend>
						</b-form-group>
						<b-form-group label-align-sm="right" label-for="newPassword" size="sm">
							<b-input-group-prepend>
								<span class="input-group-text"><i class="fa fa-key"></i></span>
								<b-form-input size="sm" type="password"
									:placeholder="$t('users-l.update.newPasswordChange')" id="newPasswordchange"
									v-model="payload.newPasswordConfirm" />
							</b-input-group-prepend>
						</b-form-group>

						<div class="row top mt-3 justify-content-end">
							<div class="col-4">
								<b-button size="sm" variant="outline-danger" block @click="closeChangePasswordModal">
									{{ $t('actions.cancel') }}
								</b-button>
							</div>
							<div class="col-4">
								<b-button size="sm" variant="outline-success" block @click="changeMyPassword">
									{{ $t('actions.save') }}
								</b-button>
							</div>
						</div>

					</div>
				</b-modal>
				<!--<b-modal v-model="modalShow" @ok="handleOk">
					Do you want to logout?
				</b-modal>-->
			</b-navbar-nav>
			<!--<AsideToggler class="d-none d-lg-block"/>-->
			<!--<AsideToggler class="d-lg-none" mobile />-->
		</AppHeader>
		<div class="app-body">
			<AppSidebar fixed>
				<SidebarHeader />
				<SidebarForm />
				<SidebarNav :navItems="getSidebarItemsWithRefs" ref="sidebarNav" :badge="10"></SidebarNav>
				<SidebarFooter />
				<SidebarMinimizer />
			</AppSidebar>
			<main class="main">
				<!--<Breadcrumb :list="list"/>-->
				<div class="container-fluid">
					<router-view></router-view>
				</div>
			</main>
			<!--<AppAside fixed>
				&lt;!&ndash;aside&ndash;&gt;
				<DefaultAside/>
			</AppAside>-->
		</div>
		<TheFooter class="hidden-print">
			<!--footer-->
			<div>
				<a href="http://dataprizma.uz/">Dataprizma.uz</a>
				<span class="ml-1">&copy; 2022 creativeIdeas.</span>
			</div>
			<div class="ml-auto">
				<span class="mr-1">Powered by</span>
				<a href="http://dataprizma.uz/">Dataprizma UZ</a>
			</div>
		</TheFooter>
	</div>
</template>

<script>
// import nav from '@/_nav'
import {
	Header as AppHeader,
	SidebarToggler,
	Sidebar as AppSidebar,
	SidebarFooter,
	SidebarForm,
	SidebarHeader,
	SidebarMinimizer,
	SidebarNav,
	Aside as AppAside,
	AsideToggler,
	Footer as TheFooter,
	Breadcrumb
} from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import { mapActions, mapGetters, mapState } from 'vuex'
import { TokenService } from "../services/storage.service";
import { UserService } from "../services/user.service";
import PermissionsService from "../services/permissions.service";
import itemValuesService from "../views/warehouse-management/min-max-values/item.values.service";
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import ContractService from "../views/contract-management/contract.service";
import { BOverlay } from 'bootstrapVue2';

export default {
	name: 'DefaultContainer',
	components: {
		AsideToggler,
		AppHeader,
		AppSidebar,
		AppAside,
		TheFooter,
		Breadcrumb,
		DefaultAside,
		DefaultHeaderDropdownAccnt,
		SidebarForm,
		SidebarFooter,
		SidebarToggler,
		SidebarHeader,
		SidebarNav,
		SidebarMinimizer,
		BOverlay,
		'el-dropdown': Dropdown,
		'el-dropdown-menu': DropdownMenu,
		'el-dropdown-item': DropdownItem
	},
	data() {
		return {
			modalShow: false,
			passwordModal: false,
			expiredItemsCount: 0,
			minMaxItemsCount: {},
			payload: {
				id: null,
				currentPassword: '',
				newPassword: '',
				newPasswordConfirm: '',
			},
			isIncorrectForm: false,
			passwordMismatch: false,
			currentUserName: TokenService.getUserName() ? TokenService.getUserName() : ' ',
			departmentSaleType: TokenService.getDepSaleType() ? TokenService.getDepSaleType() : ' '
		}
	},
	methods: {
		async changeLocale(newLocale) {
			if (this.$i18n.locale !== newLocale) {
				window.location.reload();
				await this.setLocale(newLocale);
			}
		},
		removeOpened() {
			this.$refs.sidebarNav.$el.childNodes[0].childNodes[0].childNodes.forEach(element => {
				element.classList.remove("open")
			});
		},
		goToContract(id) {
			this.$router.push(`/contract/doc/view/${id}`)
		},
		...mapActions([
			'logout'
		]),
		...mapActions('references', [
			'getReferencesList'
		]),
		...mapActions('contragents', [
			'getNotificationList'
		]),
		...mapActions('users', [
			'updateUserSelfPass'
		]),
		...mapActions('locales', [
			'setLocale'
		]),
		makeReferences(refs) {
			let array = [];
			if (refs.length > 0) {
				for (let ref of refs) {
					if (ref.code) {
						let obj = {};
						obj.name = ref.name ? ref.name.charAt(0).toUpperCase() + ref.name.slice(1).toLowerCase() : '';
						obj.url = `/references/${ref.code.toLowerCase()}`;
						obj.icon = 'fa fa-search';
						array.push(obj);
					}
				}
			}
			return array;
		},
		showChangePasswordModal() {
			this.payload.currentPassword = '';
			this.payload.newPassword = '';
			this.payload.newPasswordConfirm = '';
			this.isIncorrectForm = false;
			this.passwordMismatch = false;
			this.$store.commit('users/setUserPasswordChangeError', { message: '', boolean: false });
			if (this.passwordModal) {
				this.closeChangePasswordModal();
			} else {
				this.passwordModal = true;
			}
		},
		closeChangePasswordModal() {
			this.passwordModal = false
		},
		scrollToTop() {
			window.scrollTo(0, 0);
		},
		async changeMyPassword() {
			this.payload.id = TokenService.getCurrentUserId();
			if (this.payload.currentPassword != '' && this.payload.newPassword != '' && this.payload.newPasswordConfirm != '') {
				if (this.payload.newPassword === this.payload.newPasswordConfirm) {
					await this.updateUserSelfPass(this.payload);
					if (!this.hasPasswordError) {
						this.$vs.notify({
							text: 'Пароль успешно изменен',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
						this.passwordModal = false;
					}
					this.isIncorrectForm = false;
					this.passwordMismatch = false;
				} else {
					this.isIncorrectForm = false;
					this.passwordMismatch = true;
					this.passwordModal = true;
				}
			} else {
				this.isIncorrectForm = true;
				this.passwordMismatch = false;
				this.passwordModal = true;
			}
		}
	},
	computed: {
		...mapGetters('references', [
			'getReferences'
		]),
		...mapGetters('contragents', [
			'contracts', 'notifyLoading'
		]),
		...mapState(['isCashier', 'isContragent', 'isAdmin', 'userName', 'isMonitoring']),
		...mapState('users', ['passwordErrorMessage', 'hasPasswordError']),
		getSidebarItemsWithRefs() {
			let report = null;
			let wholeReport = null;
			if (TokenService.getDepSaleType() === 'WHOLE' || this.isAdmin) {
				wholeReport = {
					name: this.$t('sidebar.reports.wholesale'),
					url: '/warehouse-management/report',
					icon: 'fa fa-file-text',
					hasPerm: this.$can('view', 'pos-whole-reports')
				}
			}
			if (TokenService.getDepSaleType() === 'RETAIL' || this.isAdmin) {
				report = {
					name: this.$t('sidebar.reports.title'),
					url: '/point-of-sale/report',
					icon: 'fa fa-file-text',
					hasPerm: this.$can('view', 'pos-reports')
				}
			}
			let tempArrayForReport = [];
			// if ((this.departmentSaleType == 'WHOLE' || this.isAdmin) && wholeReport) {
			// 	tempArrayForReport.push(wholeReport);
			// }
			if ((this.departmentSaleType == 'RETAIL' || this.isAdmin) && report) {
				tempArrayForReport.push(report);
			}
			let temp1 = [
				{
					name: this.$t('sidebar.dashboard'),
					url: '/dashboard',
					icon: 'icon-speedometer',
					hasPerm: true
				},
				{
					name: this.$t('sidebar.pos.title'),
					url: '/post',
					icon: 'fa fa-shopping-cart',
					children: [
						// {
						// 	name: this.$t('sidebar.pos.pos'),
						// 	url: '/point-of-sale/pos',
						// 	icon: 'fa fa-home',
						// 	hasPerm: this.departmentSaleType === 'RETAIL' && this.$can('view', 'pos')
						// },
						{
							name: this.$t('sidebar.pos.pos'),
							url: '/point-of-sale/before-pos',
							icon: 'fa fa-home',
							hasPerm: this.departmentSaleType === 'RETAIL' && this.$can('view', 'pos')
						},
						{
							name: this.$t('sidebar.sales.title'),
							url: '/point-of-sale/sales',
							icon: 'fa fa-shopping-cart',
							hasPerm: (this.departmentSaleType === 'RETAIL' && this.$can('view', 'sales')) || this.isAdmin
						},
						// {
						// 	name: this.$t('sidebar.warehouse-management.wholesale'),
						// 	url: '/warehouse-management/wholesale',
						// 	icon: 'fa fa-shopping-cart',
						// 	hasPerm: (this.departmentSaleType === 'WHOLE' && this.$can('view', 'wholesale')) || this.isAdmin
						// },
						// {
						// 	name: this.$t('sidebar.pos.clients'),
						// 	url: '/point-of-sale/clients',
						// 	icon: 'fa fa-group',
						// 	hasPerm: (this.departmentSaleType === 'RETAIL' && this.$can('view', 'clients')) || this.isAdmin
						// },
						// {
						// 	name: this.$t('sidebar.pos.certificates'),
						// 	url: '/point-of-sale/certificates',
						// 	icon: 'fa fa-address-card',
						// 	hasPerm: this.$can('view', 'certificates')
						// },
						// {
						// 	name: this.$t('sidebar.pos.discountForCard'),
						// 	url: '/point-of-sale/discountForCard',
						// 	icon: 'fa fa-gear',
						// 	hasPerm: (this.$can('view', 'discount-for-card') && this.departmentSaleType === 'RETAIL') || this.isAdmin
						// },
					]
				},
				{
					name: this.$t('restaurant.title'),
					url: '#',
					icon: 'fas fa-utensils',
					children: [
						{
							name: this.$t('restaurant.group'),
							url: '/restaurant/group',
							icon: 'fas fa-layer-group',
							hasPerm: this.$can('view', 'restaurant-category')
						},
						{
							name: this.$t('restaurant.product'),
							url: '/restaurant/product',
							icon: 'fas fa-shopping-basket',
							hasPerm: this.$can('view', 'restaurant-item')
						},
						//	{
						//		name: this.$t('restaurant.pos'),
						//		url: '/restaurant/pos',
						//		icon: 'fas fa-shopping-cart',
						//		hasPerm: this.$can('view', 'restaurant-pos')
						//	}
					]
				},
				// {
				// 	name: this.$t('air_cafe.title'),
				// 	url: '#',
				// 	icon: 'fas fa-utensils',
				// 	children: [
				// 		{
				// 			name: this.$t('air_cafe.category'),
				// 			url: '/air-cafe/category',
				// 			icon: 'fas fa-layer-group',
				// 			hasPerm: this.$can('view', 'aircafe-category')
				// 		},
				// 		{
				// 			name: this.$t('restaurant.product'),
				// 			url: '/air-cafe/product',
				// 			icon: 'fas fa-shopping-basket',
				// 			hasPerm: this.$can('view', 'aircafe-item')
				// 		},
				// 	]
				// },
				// {
				// 	name: 'Sky-Shop',
				// 	url: '#',
				// 	icon: 'fa fa-shopping-bag',
				// 	children: [
				// 		{
				// 			name: 'Параметры',
				// 			url: '/sky-shop/settings',
				// 			icon: 'fa fa-gear',
				// 			hasPerm: this.$can('view', 'skyshop-setting')
				// 		},
				// 		{
				// 			name: 'Накладной',
				// 			url: '/sky-shop/doc',
				// 			icon: 'fa fa-th-list',
				// 			hasPerm: this.$can('view', 'skyshop-doc')
				// 		},
				// 		{
				// 			name: 'Отчёты SkyShop',
				// 			url: '/sky-shop/report',
				// 			icon: 'fa fa-file-text',
				// 			hasPerm: this.$can('view', 'skyshop-doc')
				// 		},
				// 		{
				// 			name: 'Бригада',
				// 			url: '/sky-shop/brigade',
				// 			icon: 'fa fa-cogs',
				// 			hasPerm: this.$can('view', 'skyshop-setting')
				// 		},
				// 		{
				// 			name: `Sky ${this.$t('sidebar.references.currency-rates')}`,
				// 			url: '/references/sky-currency-rates',
				// 			icon: 'fa fa-money',
				// 			hasPerm: this.$can('view', 'currency-rates')
				// 		}
				// 	]
				// },
				// {
				// 	name: 'Управление контрактами',
				// 	url: '#',
				// 	icon: 'fa fa-address-book',
				// 	children: [
				// 		{
				// 			name: 'Тип контракта',
				// 			url: '/contract/type',
				// 			icon: 'fa fa-info-circle',
				// 			hasPerm: this.$can('view', 'contract-reference')
				// 		},
				// 		{
				// 			name: 'Тип контрагента',
				// 			url: '/contract/stage',
				// 			icon: 'fa fa-info-circle',
				// 			hasPerm: this.$can('view', 'contract-reference')
				// 		},
				// 		{
				// 			name: 'Контракт',
				// 			url: '/contract/doc',
				// 			icon: 'fa fa-th-list',
				// 			hasPerm: this.$can('view', 'contract-doc')
				// 		}
				// 	]
				// },
				{
					name: this.$t('sidebar.warehouse-management.title'),
					url: '#',
					icon: 'fa fa-home',
					children: [
						{
							name: this.$t('sidebar.warehouse-management.warehouses'),
							url: '/warehouse-management/warehouses',
							icon: 'fa fa-home',
							hasPerm: this.$can('view', 'warehouses')
						},
						// {
						// 	name: this.$t('sidebar.warehouse-management.booking'),
						// 	url: '/warehouse-management/booking',
						// 	icon: 'fa fa-bookmark',
						// 	hasPerm: this.$can('view', 'booking')
						// },
						{
							name: this.$t('sidebar.warehouse-management.income'),
							url: '/warehouse-management/income',
							icon: 'fa fa-pencil-square-o',
							hasPerm: this.$can('view', 'incomes')
						},
						{
							name: this.$t('sidebar.warehouse-management.requests') + ' (Менежер)',
							url: '/request-warehouse/transfer',
							icon: 'fa fa-file-text',
							hasPerm: this.$can('view', 'request-documents')
						},
						{
							name: this.$t('sidebar.warehouse-management.requests') + ' (Кладовщик)',
							url: '/request-warehouse/counter',
							icon: 'fa fa-file-text-o',
							hasPerm: this.$can('view', 'checking request-documents')
						},
						{
							name: this.$t('sidebar.warehouse-management.transfers'),
							url: '/warehouse-management/transfers',
							icon: 'fa fa-money',
							hasPerm: this.$can('view', 'transfers')
						},
						{
							name: this.$t('sidebar.warehouse-management.discount_refuse'),
							url: '/warehouse-management/discount-refuse',
							icon: 'fa fa-money',
							hasPerm: this.$can('view', 'discount-refuse')
						},
						// {
						// 	name: this.$t('sidebar.warehouse-management.transferbydocument'),
						// 	url: '/warehouse-management/transfer-by-document',
						// 	icon: 'fa fa-forward',
						// 	hasPerm: this.$can('view', 'transfer-by-document')
						// },

						// {
						// 	name: this.$t('sidebar.warehouse-management.expense'),
						// 	url: '/warehouse-management/expense',
						// 	icon: 'fa fa-pencil-square-o',
						// 	hasPerm: this.$can('list', 'warehouse-documents-expense')
						// },
						{
							name: this.$t('sidebar.warehouse-management.expiredItems'),
							url: '/warehouse-management/expired-items',
							icon: 'fas fa-cookie-bite',
							hasPerm: this.$can('view', 'expired-items'),
							badge: {
								variant: 'primary',
								text: `${this.expiredItemsCount ? this.expiredItemsCount : 0}`
							}
						},
						{
							name: 'Мин Макс значении товара',
							url: '/warehouse-management/min-max-values',
							icon: 'fas fa-bell',
							hasPerm: this.$can('view', 'min-max'),
							badge: {
								variant: 'danger',
								text: `${this.minMaxItemsCount ? (this.minMaxItemsCount.min ? this.minMaxItemsCount.min : 0 + this.minMaxItemsCount.max ? this.minMaxItemsCount.max : 0) : 0}`
							}
						},
						{
							name: 'Продление срока годности',
							url: '/warehouse-management/term-of-items',
							icon: 'fa fa-calendar-plus-o',
							hasPerm: this.$can('view', 'spisatTermOfItem')
						},
						{
							name: this.$t('sidebar.warehouse-management.write-offs'),
							url: '/warehouse-management/write-offs',
							icon: 'fa fa-minus-square-o',
							hasPerm: this.$can('view', 'write-offs')
						},
						{
							name: this.$t('sidebar.warehouse-management.inventory'),
							url: '/warehouse-management/inventory',
							icon: 'fa fa-check-square-o',
							hasPerm: this.$can('view', 'inventory')
						},
						{
							name: 'Преобразовать товары',
							url: '/warehouse-management/item-convert',
							icon: 'fa fa-exchange',
							hasPerm: this.$can('view', 'item-convert')
						},
						// {
						// 	name: 'Упаковать товары',
						// 	url: '/warehouse-management/item-collect',
						// 	icon: 'fa fa-exchange',
						// 	hasPerm: this.$can('view', 'item-convert')
						// },

						// {
						// 	name: this.$t('excel-export.title'),
						// 	url: '/warehouse-management/excel-export',
						// 	icon: 'fa fa-file',
						// 	hasPerm: this.$can('list', 'items')
						// },

						// {
						//     name: this.$t('sidebar.warehouse-management.adjustment'),
						//     url: '/warehouse-management/adjustment',
						//     icon: 'fa fa-list-ol'
						// },
						// {
						// 	name: this.$t('sidebar.warehouse-management.warehouses'),
						// 	url: '/warehouse-management/warehouses',
						// 	icon: 'fa fa-home',
						// 	hasPerm: this.$can('list', 'warehouse-balances')
						// },


					]
				},
				{
					name: this.$t('sidebar.management.title'),
					url: '#',
					icon: 'fa fa-handshake-o',
					children: [
						// {
						// 	name: this.$t('sidebar.warehouse-management.extra-cost'),
						// 	url: '/warehouse-management/extra-cost',
						// 	icon: 'fa fa-usd',
						// 	hasPerm: this.$can('view', 'extra-cost')
						// },
						{
							name: this.$t('sidebar.pos.prices'),
							url: '/point-of-sale/prices',
							icon: 'fa fa-money',
							hasPerm: this.$can('view', 'pricing')
						},
						{
							name: this.$t('sidebar.pos.PriceControl'),
							url: '/point-of-sale/priceControl',
							icon: 'fa fa-gear',
							hasPerm: this.$can('view', 'pricing-percentage')
						},
						{
							name: this.$t('prices.radioButtons.pricingItemsWithDifferentPrices'),
							url: '/point-of-sale/itemWithDifferentPrices',
							icon: 'fa fa-shopping-basket',
							hasPerm: this.$can('items', 'with different price')
						},
						{
							name: 'История товара',
							url: '/item-history',
							icon: 'fa fa-history',
							// hasPerm: this.$can('items', 'with different price')
						},
						// {
						// 	name: 'История документа',
						// 	url: '/doc-history',
						// 	icon: 'fa fa-history',
						// 	// hasPerm: this.$can('items', 'with different price')
						// },
						{
							name: this.$t('sidebar.pos.sale'),
							url: '/point-of-sale/sale',
							icon: 'fa fa-gift',
							hasPerm: this.$can('view', 'discounts')
						},
						{
							name: this.$t('sidebar.pos.settings'),
							url: '/point-of-sale/settings',
							icon: 'fa fa-cogs',
							hasPerm: this.$can('view', 'settings')
						},
						// {
						// 	name: this.$t('sidebar.pos.cashboxCategory'),
						// 	url: '/point-of-sale/cashbox-category',
						// 	icon: 'fa fa-cogs',
						// 	// hasPerm: this.$can('view', 'settings')
						// },
						{
							name: this.$t('sidebar.pos.cashboxCategory'),
							url: '/point-of-sale/cashbox-category',
							icon: 'fa fa-cogs',
							// hasPerm: this.$can('view', 'settings')
						},
						// {
						// 	name: this.$t('expenses.title'),
						// 	url: '/warehouse-management/expenses',
						// 	icon: 'fa fa-money',
						// 	hasPerm: this.$can('view', 'expenses')
						//
						// },
						// ...tempArrayForReport,
					]
				},
				// {
				// 	name: this.$t('sidebar.pricing.title'),
				// 	url: '#',
				// 	icon: 'fa fa-handshake-o',
				// 	children: [
				//
				// 	]
				// },
				// {
				// 	name: this.$t('sidebar.contracts-management.title'),
				// 	url: '/contracts-management',
				// 	icon: 'fa fa-handshake-o',
				// 	children: [
				// 		{
				// 			name: this.$t('sidebar.contracts-management.contracts'),
				// 			url: '/contracts-management/contracts',
				// 			icon: 'fa fa-handshake-o',
				// 			hasPerm: this.$can('view', 'contracts')
				// 		},
				// 		{
				// 			name: this.$t('sidebar.contracts-management.transactions'),
				// 			url: '/contracts-management/transactions',
				// 			icon: 'fa fa-refresh',
				// 			hasPerm: this.$can('view', 'transactions')
				// 		}
				// 	]
				// },
				// {
				// 	name: this.$t('sidebar.user-management.title'),
				// 	url: '/user-management',
				// 	icon: 'fa fa-user-o',
				// 	hasPerm: this.isAdmin || this.$can('view', 'users'),
				// 	children: [
				// 	]
				// },
				{
					name: 'Администрирование',
					url: '#',
					icon: 'fa fa-university',
					hasPerm: !this.isCashier,
					children: [
						{
							name: this.$t('sidebar.organization-structure.departments'),
							url: '/organization-structure/departments',
							icon: 'fa fa-building',
							hasPerm: this.$can('view', 'departments') || this.isAdmin,
						},
						{
							name: this.$t('sidebar.organization-structure.employees'),
							url: '/organization-structure/employees',
							icon: 'icon icon-people',
							hasPerm: this.$can('view', 'employees') || this.isAdmin,
						},
						{
							name: this.$t('sidebar.user-management.roles'),
							url: '/user-management/roles',
							icon: 'fa fa-id-card-o',
							hasPerm: this.isAdmin || this.$can('view', 'roles')
						},
						{
							name: this.$t('sidebar.user-management.permissions'),
							url: '/user-management/permissions',
							icon: 'fa fa-unlock-alt',
							hasPerm: this.isAdmin || this.$can('view', 'permissions')
						},
						{
							name: this.$t('Добавить пользователя'),
							url: '/user-management/add-employee-with-user',
							icon: 'fa fa-unlock-alt',
							hasPerm: this.isAdmin || this.$can('view', 'employee-with-user')
						},
						{
							name: this.$t('sidebar.user-management.users'),
							url: '/user-management/users',
							icon: 'fa fa-users',
							hasPerm: this.isAdmin || this.$can('view', 'users')
						},
						// {
						// 	name: this.$t('sidebar.warehouse-management.sector'),
						// 	url: '/warehouse-management/sector',
						// 	icon: 'fa fa-list-alt',
						// 	hasPerm: this.$can('view', 'sector')
						// }
					]
				},
				{
					name: this.$t('sidebar.references.title'),
					url: '#',
					icon: 'fa fa-search-plus',
					children: [
						{
							name: this.$t('sidebar.warehouse-management.products'),
							url: '/warehouse-management/goods',
							icon: 'fa fa-shopping-basket',
							hasPerm: this.$can('view', 'goods')
						},
						{
							name: 'MXIK',
							url: '/warehouse-management/mxik',
							icon: 'fas fa-list-alt',
							hasPerm: this.$can('view', 'goods')
						},
						{
							name: this.$t('sidebar.references.counterparties'),
							url: '/references/counterparties',
							icon: 'icon icon-people',
							hasPerm: this.$can('view', 'counterparties') || this.isAdmin
						},
						{
							name: this.$t('sidebar.references.parentRefs'),
							url: '/references/parentRefs',
							icon: 'fa fa-search',
							attributes: { id: 'allParentRefs' },
							hasPerm: this.$can('view', 'parent-references')
						},
						{
							name: this.$t('sidebar.references.currency-rates'),
							url: '/references/currency-rates',
							icon: 'fa fa-money',
							hasPerm: this.$can('view', 'currency-rates')
						},
					],
				},
				// {
				// 	name: this.$t('sidebar.warehouse-management.request-document'),
				// 	url: '/request-warehouse',
				// 	icon: 'fa fa-file-text',
				// 	children: [
				// 		{
				// 			name: this.$t('sidebar.warehouse-management.items-section2'),
				// 			url: '/request-warehouse/Index',
				// 			icon: 'fa fa-list',
				// 			hasPerm: this.$can('view', 'request-less-than-five')
				// 		},
				// 		{
				// 			name: this.$t('sidebar.warehouse-management.requests'),
				// 			url: '/request-warehouse/transfer',
				// 			icon: 'fa fa-money',
				// 			hasPerm: this.$can('view', 'request-documents')
				// 		},
				// 		{
				// 			name: this.$t('sidebar.warehouse-management.request-production'),
				// 			url: '/request-warehouse/items',
				// 			icon: 'fa fa-money',
				// 			hasPerm: this.$can('view', 'request-to-manufacturer')
				// 		},
				// 	]
				// },
				// {
				// 	name: this.$t('analytics'),
				// 	url: '/analytics',
				// 	icon: 'fa fa-bar-chart',
				// 	hasPerm: this.$can('view', 'analytics'),
				// 	children: [
				// 		{
				// 			name: this.$t('analytics'),
				// 			url: '/analytics',
				// 			icon: 'fa fa-bar-chart',
				// 			hasPerm: this.$can('view', 'analytics')
				// 		},
				// 		{
				// 			name: this.$t('whole-report'),
				// 			url: '/whole-report',
				// 			icon: 'fa fa-bar-chart',
				// 			hasPerm: this.$can('view', 'analytics-by-item')
				// 		},
				// 	]
				// },
				{
					name: this.$t('whole-report'),
					url: '#',
					icon: 'fa fa-bar-chart',
					hasPerm: this.$can('view', 'analytics-by-item'),
					children: [
						{
							name: 'Balance Log Tahlili',
							url: '/report-balance-log',
							icon: 'fa fa-list',
							hasPerm: this.$can('report', 'balance_log')
						},
						{
							name: 'Каталог товаров',
							url: '/report-product-catalog',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-five')
						},
						{
							name: 'Отчет № 5',
							url: '/report',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-five')
						},
						{
							name: 'Отчет № 5*',
							url: '/report-5',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-five-one-star')
						},
						{
							name: 'Отчет № 5**',
							url: '/report-51',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-five-two-star')
						},
						{
							name: 'Отчет № 16',
							url: '/report4',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-sixteen')
						},
						{
							name: 'Отчет № 16*',
							url: '/report40',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-sixteen-one-star')
						},
						{
							name: 'Отчет № 16**',
							url: '/report41',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-sixteen-two-star')
						},
						{
							name: 'Отчет № 23',
							url: '/report6',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-twenty-three')
						},
						{
							name: 'Отчет № 30',
							url: '/report3',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-Thirty')
						},
						{
							name: 'Отчет № 31',
							url: '/report1',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-Thirty-one')
						},
						{
							name: 'Отчет № 31 *',
							url: '/report31',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-Thirty-one-star')
						},
						{
							name: 'Средний чек (по кассирам)',
							url: '/averageCheckByUsername',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'average-check-by-username')
						},
						{
							name: 'Отчет по выручкам',
							url: '/TotalSaleByPeriodAndDepartment',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'total-sale-by-period-and-department')
						},
						{
							name: 'Отчет № 49',
							url: '/report2',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-forty-nine')
						},
						{
							name: 'Отчет KPI',
							url: '/report-kpi',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-kpi')
						},
						{
							name: 'Остатки по дням',
							url: '/report5',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-Balances-by-day')
						},
						{
							name: 'Отчет по валютам',
							url: '/report50',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-currency')
						},
						{
							name: 'Отчет по валютам по дням',
							url: '/report50Test',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-currency')
						},
						{
							name: 'Средний чек',
							url: '/ReportAverageCheck',
							icon: 'fa fa-bar-chart',
							// hasPerm: this.$can('view', 'average-check')
						},
						{
							name: 'Остатки по поставщикам',
							url: '/report42',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-Balances-by-suppliers')
						},
						{
							name: 'Продажа по сменам',
							url: '/SaleItemsWithGroupByUsername',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'sales-by-username')
						},
						// {
						// 	name: 'Отчет № 52',
						// 	url: '/report-52',
						// 	icon: 'fa fa-bar-chart',
						// 	hasPerm: this.$can('view', 'analytics-by-item')
						// },
						{
							name: 'Продажи по импорт',
							url: '/report-53',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-Sales-by-import')
						},
						{
							name: 'Остатки по импорт',
							url: '/report-54',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-Import-balances')
						},
						{
							name: 'Приход  по поставщикам  ',
							url: '/report-55',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'report-Income-by-suppliers')
						},
						{
							name: 'Отчёт по чекам  ',
							url: '/report15',
							icon: 'fa fa-bar-chart',
							hasPerm: this.$can('view', 'Check-report')
						},
					]
				},
				// {
				// 	name: this.$t('sidebar.references.counterparties'),
				// 	url: '/contragents',
				// 	icon: 'icon icon-people',
				// 	// hasPerm: this.$can('view', 'analytics'),
				// 	children: [
				// 		{
				// 			name: this.$t('sidebar.warehouse-management.requests'),
				// 			url: '/contragents/orders',
				// 			icon: 'fa fa-bar-chart',
				// 			hasPerm: this.$can('view', 'analytics')
				// 		},
				//
				// 	]
				// },
				{
					name: this.$t('Мониторинг'),
					url: '#',
					icon: 'fa fa-bar-chart',
					hasPerm: this.$can('menu', 'monitoring'),
					children: [
						{
							name: this.$t('sidebar.warehouse-management.income'),
							url: '/monitoring/warehouse-management/income',
							icon: 'fa fa-pencil-square-o',
							hasPerm: this.$can('view', 'income-document-monitoring')
						},
						{
							name: this.$t('sidebar.warehouse-management.transfers'),
							url: '/monitoring/warehouse-management/transfer',
							icon: 'fa fa-pencil-square-o',
							hasPerm: this.$can('view', 'transfer-document-monitoring')
						},
						{
							name: 'Возвраты перемещения',
							url: '/monitoring/warehouse-management/transfer-return',
							icon: 'fa fa-pencil-square-o',
							hasPerm: this.$can('view', 'transfer-document-return-monitoring')
						},
						{
							name: this.$t('sidebar.warehouse-management.products'),
							url: '/monitoring/warehouse-management/goods',
							icon: 'fa fa-shopping-basket',
							hasPerm: this.$can('view', 'item-monitoring')
						},
					]
				},
				{
					divider: true
				},
			].filter(el => {
				if ('children' in el) {
					el.children = el.children.filter(child => {
						if ('hasPerm' in child) {
							if (child.hasPerm) {
								return child;
							}
						} else {
							return child;
						}
					});
				}
				if ('hasPerm' in el) {
					if (el.hasPerm) {
						if ('children' in el) {
							if (el.children.length > 0) {
								return el;
							}
						}
					}
				} else {
					if ('children' in el) {
						if (el.children.length > 0) {
							return el;
						}
					} else {
						return el;
					}
				}
			});
			if (this.$can('view', 'references')) {
				let foundIndex = temp1.findIndex(x => (x.name === 'Справочники' || x.name === 'Referinte' || x.name === 'Маълумотнома' || x.name === 'Ma\'lumotnoma'));
				if (foundIndex > -1) {
					if (foundIndex > -1) {
						let tempChildren = [...temp1[foundIndex].children, ...this.makeReferences(this.getReferences)];
						if (temp1[foundIndex].children.length <= 5) {
							temp1[foundIndex].children = [...tempChildren];
						}
					}
				}
			}
			if (this.isContragent) {
				return [
					{
						name: this.$t('sidebar.dashboard'),
						icon: 'fa fa-home',
						children: [
							{
								name: this.$t('sidebar.contragent'),
								url: '/contragent',
								icon: 'fa fa-user',
							},
							{
								name: this.$t('sidebar.warehouse-management.requests'),
								url: '/request-product',
								icon: 'fa fa-file-text',
							},
						]
					},

				]
			} else {
				return temp1;
			}
		},

		...mapGetters('locales', [
			'locales', 'locale'
		]),
		name() {
			return this.$route.name
		},
		list() {
			return this.$route.matched.filter((route) => route.name || route.meta.label)
		}
	},
	async created() {
		if (this.$can('list', 'parent references')) {
			await this.getReferencesList();
		}
		if (this.$can('contract-notification', 'view')) {
			this.getNotificationList();
		}
		setTimeout(() => {
			let menu = this.$refs.sidebarNav.$el.childNodes[0].childNodes[0].childNodes;

			menu.forEach(function (el) {
				if (el.childNodes[0]) {
					el.childNodes[0].addEventListener("click", function (e) {
						// In click dashboard close all opened menu
						if (el.firstChild.href) {
							menu.forEach(element => {
								element.classList.remove("open")
							});
						}

						if (el.className.includes("open")) {
							menu.forEach(element => {
								element.classList.remove("open")
							});
							el.classList.add("open");
							el.style.WebKitanimation = " 4s 2";
						} else {
							el.classList.remove('open')
						}
					})
				}
			})
		}, 100)
	},
	async mounted() {
		if (this.$can('view', 'expired-items')) {
			await PermissionsService.getExpiredItemsCount().then(res => {
				this.expiredItemsCount = res.data
			})
		}
		if (this.$can('view', 'min-max')) {
			await itemValuesService.getItemValuesCounts().then(res => {
				this.minMaxItemsCount = res.data
			})
		}
	}
}
</script>

<style scoped lang="scss">
#userName {
	color: #000;
	cursor: default;
}

@page {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}

	.print {
		display: block;
	}

	.card {
		box-shadow: none;
	}
}
</style>
